const gradientTextStyle = {
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}

export default gradientTextStyle
